
import { computed, defineComponent, onMounted, ref } from 'vue'
import SpinnerLoader from '../../../components/SpinnerLoader.vue'
import Breadcrumbs from '../../../components/Breadcrumbs.vue'
import { useProject } from '../../../hooks/useProject'
import { useBillingStore } from '@/store/stores/billing'
import { useTabs } from '../../../hooks/useTabs'
import Subscriptions from '@/modules/marketplace/components/billing/tabsViews/Subscriptions.vue'
import Tariffs from '@/modules/marketplace/components/billing/tabsViews/Tariffs.vue'
import TariffIntegrationsTable from '../components/billing/TariffIntegrationsTable.vue'
import PaymentSidebar from '../components/billing/PaymentSidebar.vue'
import cfg from '@root/config'
import { useUser } from '@/hooks/useUser'
export default defineComponent({
    components: {
        SpinnerLoader,
        Breadcrumbs,
        TariffIntegrationsTable,
        PaymentSidebar,
        Subscriptions,
        Tariffs,
    },
    props: {},
    setup() {
        const { project } = useProject()
        const { user } = useUser()
        const billingStore = useBillingStore()
        const loading = ref(false)
        onMounted(async () => {
            const projectId = project.value?.id
            if (!projectId) return
            loading.value = true
            await Promise.all([
                billingStore.fetchCurrentTariff(projectId),
                billingStore.fetchTariffs(projectId),
            ])
            loading.value = false
        })

        const billingTabs = computed(() => [
            {
                tabName: 'Подписки',
                sectionName: 'subscriptions',
                component: Subscriptions,
            },
            {
                tabName: 'Тариф',
                sectionName: 'tariffs',
                component: Tariffs,
            },
            // закомментировано, так как пока не готовы соответсвующие модули на бекенде
            // {
            //     tabName: 'ИНТЕГРАЦИИ',
            //     sectionName: 'integrations',
            //     component: Tariffs,
            // },
            // {
            //     tabName: 'ИСТОРИЯ ОПЛАТЫ',
            //     sectionName: 'payHistory',
            //     component: Tariffs,
            // },
        ])
        const { activeTab, tabs } = useTabs({
            tabs: billingTabs,
            defaultSectionName: computed(() => 'subscriptions'),
        })
        const isSubscriptionsPage = computed(() => {
            const section = tabs.value[activeTab.value]?.sectionName
            return section === 'subscriptions'
        })
        const pageTitle = computed(() => (isSubscriptionsPage.value ? 'Подписка и оплата' : 'Тарифы'))
        const pageDescription = computed(() =>
            isSubscriptionsPage.value
                ? 'Текущий тариф, подключённые каналы и способы оплаты.'
                : 'Сравните тарифы и выберите подходящий для проекта.'
        )
        const goToSection = (sectionName: string) => {
            const index = tabs.value.findIndex(tab => tab.sectionName === sectionName)
            if (index >= 0 && activeTab.value !== index) {
                activeTab.value = index
            }
        }
        const breadcrumbs = computed(() => [
            {
                text: project.value.name,
                to: `/project/${project.value.id}`,
            },
            {
                text: isSubscriptionsPage.value ? 'Подписка и оплата' : 'Тарифы',
                to: `/project/${project.value.id}/billing`,
                disabled: true,
            },
        ])
        const currentTariff = computed(() => billingStore.getCurrentTariff(project.value.id))
        const paymentModalRenewal = computed(() => billingStore.paymentModal.renewal)
        const paymentSidebarMode = computed(() => (billingStore.addChannelContext?.name ? 'add-channel' : 'billing'))
        const projectId = computed(() => String(project.value?.id || ''))
        const isBillingManager = computed(() => Boolean(user.value?.sub && cfg.adminsWhitelist.includes(user.value.sub)))
        return {
            loading,
            breadcrumbs,
            activeTab,
            tabs,
            isSubscriptionsPage,
            pageTitle,
            pageDescription,
            goToSection,
            currentTariff,
            paymentModalRenewal,
            paymentSidebarMode,
            projectId,
            isBillingManager,
        }
    },
})
